var React = require('react');

function CircledArrow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26.241","cy":"26.595","r":"24.7585","fill":"currentColor","key":0}),React.createElement("rect",{"x":"17.5215","y":"24.7852","width":"13.7429","height":"3.62469","fill":"#F5F1F1","key":1}),React.createElement("rect",{"x":"27.2832","y":"18.918","width":"10.8572","height":"3.62469","transform":"rotate(45 27.2832 18.918)","fill":"#F5F1F1","key":2}),React.createElement("rect",{"width":"10.8572","height":"3.62469","transform":"matrix(-0.707107 0.707107 0.707107 0.707107 32.3965 24.0312)","fill":"#F5F1F1","key":3})]);
}

CircledArrow.defaultProps = {"viewBox":"0 0 52 53","fill":"none"};

module.exports = CircledArrow;

CircledArrow.default = CircledArrow;
